module.exports = __webpack_public_path__ + "static/media/resetSuccess.87799654.svg";